/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_TitleInputs */



/**
* | output |
* | --- |
* | "Project Sync" |
*
* @param {Team_Sync_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_title = /** @type {((inputs?: Team_Sync_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektsynchronisierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизация проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización de proyectos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सिंक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronização de projetos")
	return /** @type {LocalizedString} */ ("Project Sync")
});